import { IWorkflowSelectionField } from "@gtmhub/sessions/models/models";
import { IComponentOptions } from "angular";

export class WorkflowSelectionAccordionCtrl {
  accordionName: boolean;
  isAccordionOpen: boolean;
  regularFields: IWorkflowSelectionField[];
  customFields: IWorkflowSelectionField[];
}

export const WorkflowSelectionAccordionComponent: IComponentOptions = {
  bindings: {
    accordionName: "<",
    isAccordionOpen: "<",
    regularFields: "<",
    customFields: "<",
  },

  controller: WorkflowSelectionAccordionCtrl,
  templateUrl: require("./workflow-selection-accordion.jade"),
};
